import { useLocation, useNavigate } from "react-router-dom";
import { useLang, switchPath, saveLang, SUPPORTED, LANG_NAMES, markLangSwitch } from "@/lib/i18n";
import { api } from "@/lib/api";
import { sendReaderEvent } from "@/lib/readerEvents";

/** Inline language bar in the header: العربية · English · Español · Nederlands — all four always visible (no menu).
 *  Switching keeps the same page (a story opens in its own translation), saves the choice and moves the device's
 *  push subscription to that language without creating a duplicate row. */
export default function LanguageSwitch({ className = "" }) {
    const { lang, t } = useLang();
    const location = useLocation();
    const navigate = useNavigate();
    const go = (target) => {
        if (target === lang) return;
        saveLang(target);
        markLangSwitch();
        sendReaderEvent("lang_change", { lang: target, target: `${lang}>${target}` });
        try {
            const ep = localStorage.getItem("push-endpoint");
            if (ep) api.post("/public/push/lang", { endpoint: ep, lang: target }).catch(() => {});
        } catch {}
        navigate(switchPath(location.pathname, location.search, target));
    };
    return (
        <span className={`beam-ring beam-ring--slow rounded-md topbar-ctl ${className}`} data-testid="language-switch" dir="ltr">
            <span className="lang-frame" role="group" aria-label={t("langLabel")} data-testid="language-switch-group">
                {SUPPORTED.map((code) => {
                    const on = lang === code;
                    return (
                        <a key={code} href={switchPath(location.pathname, location.search, code)} hrefLang={code} lang={code}
                            onClick={(e) => { e.preventDefault(); go(code); }} aria-current={on ? "true" : undefined}
                            className={`lang-opt ${on ? "lang-opt--on" : ""}`} data-testid={`lang-${code}`}>
                            {LANG_NAMES[code]}
                        </a>
                    );
                })}
            </span>
        </span>
    );
}
